<template>
  <div>
    <Row :gutter="8" class="m-b-10">
      <i-col span="3">
        <Select size="small" placeholder="所属线路" v-model="query.assetId" clearable @on-change="getStationData">
          <i-option v-for="item in assetArray" :key="'asset_' + item.id" :value="item.id">
            {{ item.name }}
          </i-option>
        </Select>
      </i-col>
      <i-col span="3">
        <Select size="small" placeholder="所属站点" v-model="query.stationId" clearable>
          <i-option v-for="item in stationArray" :key="'qStation_' + item.id" :value="item.id">
            {{ item.name }}
          </i-option>
        </Select>
      </i-col>
      <i-col span="4">
        <i-input size="small" v-model="query.keyWord" placeholder="关键字：支持资源编号、电表编号"></i-input>
      </i-col>
      <i-col span="10">
        <Button type="primary" icon="ios-search" size="small" @click="onSearchData">搜索</Button>
        <!-- <Button type="success" icon="md-cloud-upload" class="m-l-5" size="small" @click="handleAddMeter">新增电表</Button> -->
      </i-col>
    </Row>
    <Table stripe size="small" :data="tableData" :columns="tableColumns"></Table>
    <div class="paging_style">
      <Page size="small" :total="totalRow" :page-size="query.size" show-total show-elevator
        :current="query.current" @on-change="handleChangePage"></Page>
    </div>

    <Modal v-model="meterModal" footer-hide width="400">
      <p slot="header" class="text-center">编辑电表基础信息</p>

      <Form ref="formValidate" :label-width="80">
        <FormItem label="所属线路" prop="date">
          <Select size="small" placeholder="选择所属线路">
            <i-option value="1">1号线</i-option>
            <i-option value="2">2号线</i-option>
            <i-option value="3">3号线</i-option>
          </Select>
        </FormItem>
        <FormItem label="所属站点" prop="price">
          <Select size="small" placeholder="选择所属站点" clearable>
            <i-option value="1">南庄站</i-option>
            <i-option value="2">绿岛湖站</i-option>
            <i-option value="3">石湾站</i-option>
          </Select>
        </FormItem>
        <FormItem label="所属资产" prop="unit">
          <Select size="small" placeholder="选择所属资产" clearable>
            <i-option value="1">FW2-NZ-S1</i-option>
            <i-option value="2">FW2-LDH-S1</i-option>
            <i-option value="3">FW2-SW-S4</i-option>
          </Select>
        </FormItem>
        <FormItem label="电表编号" prop="unit">
          <Input style="width: 190px;" placeholder="请输入电费编号"></Input>
        </FormItem>
        <FormItem class="m-t-10">
            <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
            <Button @click="handleReset('formValidate')" style="margin-left: 8px; color: #000">重置</Button>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { getMaintenanceAssetList } from '@/api/rim/asset'
import { getStationByAssetId } from '@/api/rim/station'
import { pageElectricMeter } from '@/api/invest/electricMeter'

export default {
  data () {
    return {
      meterModal: false,

      assetArray: [],
      stationArray: [],

      query: {
        current: 1,
        size: 15,
        assetId: null,
        keyWord: null,
        stationId: null
      },

      totalRow: 0,
      tableData: [],
      tableColumns: [
        { title: '线路', key: 'assetName' },
        { title: '站点', key: 'stationName' },
        { title: '资源编号', key: 'deviceCode' },
        { title: '电表编号', key: 'meterCode' },
        {
          title: '操作',
          align: 'center',
          width: 130,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.$store.commit('set_investment_elec_basic_meter', params.row)
                    this.$store.commit('set_investment_elec_basic_pageType', 'detail')
                  }
                }
              }, '查看详情')
              // h('a', {
              //   style: { marginRight: '5px' },
              //   on: {
              //     click: () => {
              //       this.hanldeEditItem(params.row)
              //     }
              //   }
              // }, '编辑'),
              // h('a', {
              //   style: { color: '#ef4f4f' },
              //   on: {
              //     click: () => {
              //       this.handleDeleteItem(params.row)
              //     }
              //   }
              // }, '删除')
            ])
          }
        }
      ]
    }
  },
  mounted () {
    this.initPageData()
  },
  methods: {
    initPageData () {
      this.getBasicData()
      this.getAssetData()
    },
    getBasicData () {
      pageElectricMeter(this.query).then(res => {
        this.tableData = res.records
        this.totalRow = res.total
      })
    },
    getAssetData () {
      getMaintenanceAssetList().then(res => {
        if (res && !res.errcode) {
          this.assetArray = res
        } else {
          this.assetArray = []
        }
      })
    },
    getStationData () {
      if (this.query.assetId) {
        getStationByAssetId({ assetId: this.query.assetId }).then(res => {
          if (res && !res.errcode) {
            this.stationArray = res
          } else {
            this.stationArray = []
          }
        })
      } else {
        this.query.stationId = undefined
        this.stationArray = []
      }
    },
    onSearchData () {
      this.query.current = 1
      this.getBasicData()
    },
    handleChangePage (currentPage) {
      this.query.current = currentPage
      this.getBasicData()
    },
    handleAddMeter () {
      this.meterModal = true
    },
    hanldeEditItem (params) {
      this.meterModal = true
    },
    handleSubmitChange () {

    },
    handleDeleteItem (params) {
      this.$Modal.confirm({
        title: '确定删除？',
        content: '<p>确定要删除该条数据，删除后将不可恢复！</p>',
        loading: true,
        onOk: () => {
          this.$Modal.remove()
        }
      })
    }
  }
}
</script>
